var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.381836,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F48220"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0909 11.647C18.4968 11.2724 19.1294 11.2977 19.504 11.7036L22.7348 15.2035C23.0884 15.5866 23.0884 16.177 22.7348 16.5601L19.504 20.0601C19.1294 20.4659 18.4968 20.4913 18.091 20.1166C17.6851 19.742 17.6598 19.1094 18.0344 18.7036L19.716 16.8818L10 16.8818C9.44771 16.8818 9 16.4341 9 15.8818C9 15.3295 9.44771 14.8818 10 14.8818L19.716 14.8818L18.0344 13.0601C17.6598 12.6543 17.6851 12.0216 18.0909 11.647Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallArrow);
export default __webpack_public_path__ + "static/media/small-arrow.b1a4dd61d64e6e4068d1da34a9cbcb23.svg";
export { ForwardRef as ReactComponent };